import { Box, Kbd, KbdGroup, Text } from "@salestrak/ui";

/**
 * Tooltip body naming an affordance beside the keycaps that trigger it — the
 * one grammar every hotkey-advertising tooltip shares ("Search ⌘K",
 * "Collapse sidebar [", "Search in your view /"). `keys` is the same exported
 * constant the shortcuts reference derives its row from, so the tooltip and
 * the catalog cannot disagree. No keys renders the bare name: a search that
 * is not the hotkey's current target must not advertise it.
 */
export function HotkeyTooltipLabel({
  label,
  keys,
}: {
  label: string;
  keys?: readonly string[] | undefined;
}) {
  return (
    <Box align="center" direction="row" gap="xs">
      <Text size="xs">{label}</Text>
      {keys && keys.length > 0 ? (
        <KbdGroup>
          {keys.map((key) => (
            <Kbd key={key}>{key}</Kbd>
          ))}
        </KbdGroup>
      ) : null}
    </Box>
  );
}
